import globalLoader from "../common/global-loader";
import { getCardToken } from "../common/stripe";
import timer from "./countdown-timer";

require("intl-tel-input");

$(function() {
  if ($(".js-validate-checkout").length === 0) {
    return;
  }

  $(document).on("keypress", ".js-validate-checkout", function(event) {
    return event.keyCode != 13;
  });

  $(".js-validate-checkout").validate({
    ignore: ":hidden:not(.js-custom-terms-validate)",
    errorElement: "div",
    errorClass: "label__error",
    focusInvalid: true,

    highlight: function(element, errorClass) {
      const { form, id, name } = element;
      const errorBlock = $(form).find(`div[for="${id ? id : name}"]`);

      $(element)
        .closest(".js-label")
        .addClass("has-error");
      $(errorBlock).addClass(errorClass);
    },

    unhighlight: function(element, errorClass) {
      const { form, id, name } = element;
      if (!id && !name) return;
      const errorBlock = $(form).find(`div[for="${id ? id : name}"]`);

      $(element)
        .closest(".js-label")
        .removeClass("has-error");
      $(errorBlock).removeClass(errorClass);
    },
    submitHandler: function(form) {
      //Reformat the phone number if blur failed
      let intlNumber = $('input[name="phone"]').intlTelInput("getNumber", intlTelInputUtils.numberFormat.INTERNATIONAL);
      if (intlNumber) {
        $('input[name="phone"]').val(intlNumber);
      }

      $(".js-checkout-all-products").attr("disabled", true);
      timer.clear();
      getCardToken()
        .then(token => (document.getElementById("stripe_token").value = token))
        .then(() => globalLoader.showLoader())
        .then(() => form.submit())
        .catch(error => {
          $(".js-checkout-all-products").removeClass("disabled");
          $(".js-checkout-all-products").removeAttr("disabled");
          console.error(error);
        });
    },

    rules: {
      email: {
        required: true,
        laxEmail: true
      },
      lead_traveller_first_name: {
        required: true,
        minlength: 2,
        maxlength: 50
      },
      lead_traveller_last_name: {
        required: true,
        minlength: 2,
        maxlength: 50
      },
      card_name: {
        minlength: 13
      },
      card_number: {
        minlength: 15
      },
      expiration_date: {
        minlength: 4,
        futureDate: true,
        wrongMonth: true
      },
      security_code: {
        minlength: 3
      },
      zip: {
        minlength: 5,
        wrongZipCoder: true
      },
      password: {
        minlength: 8,
        laxPassword: true
      },
      phone: {
        required: true,
        wrongPhoneNumber: true
      }
    }
  });

  const firstName = $(".js-firstname-validate");
  const lastName = $(".js-lastname-validate");
  const cardName = $(".js-cardname-validate");
  const customTerms = $('.js-custom-terms-validate');

  for (let i = 0; i < firstName.length; i++) {
    $(firstName[i]).rules("add", {
      minlength: 2
    });

    $(lastName[i]).rules("add", {
      minlength: 2
    });
  }

  for (let i = 0; i < cardName.length; i++) {
    $(cardName[i]).rules("add", {
      minlength: 3
    });
  }

  for (let i = 0; i < customTerms.length; i++) {
    $(customTerms[i]).rules("add", {
      required: true,
      messages: {
        required: $('#custom-terms-checkbox-message-'+(i+1)).text()
      }
    });
  }

  jQuery.validator.addMethod(
    "laxEmail",
    function(value, element) {
      return (
        this.optional(element) ||
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gim.test(
          value
        )
      );
    },
    "Please enter a valid email address."
  );

  jQuery.validator.addMethod(
    "wrongPhoneNumber",
    function(value, element) {
      return (this.optional(element) || $(element).intlTelInput("isValidNumber"));
    },
    "Please enter a valid phone number."
  );

  jQuery.validator.addMethod(
    "laxPassword",
    function(value, element) {
      return (
        this.optional(element) ||
        /((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).*$/.test(
          value
        )
      );
    },
    "Please enter a valid password."
  );

  jQuery.validator.addMethod(
    "wrongNumber",
    function(value, element) {
      return this.optional(element) || /[0-9]/i.test(value);
    },
    "Please enter a valid number."
  );

  jQuery.validator.addMethod(
    "futureDate",
    function(value, element) {
      const now = new Date();
      const cardDate = value.split("/");

      if (
        now
          .getFullYear()
          .toString()
          .slice(-2) < cardDate[1]
      )
        return true;

      return (
        now
          .getFullYear()
          .toString()
          .slice(-2) === cardDate[1] && now.getMonth() + 1 <= cardDate[0]
      );
    },
    "The date can not be less of current."
  );

  jQuery.validator.addMethod(
    "wrongMonth",
    function(value, element) {
      const cardDate = value.split("/");

      return cardDate[0] < 13;
    },
    "Number of month can not be more than 12"
  );

  jQuery.validator.addMethod(
    "wrongZipCoder",
    function(value, element) {
      return this.optional(element) || /[A-Z0-9 -]/gim.test(value);
    },
    "Please Enter a Valid Zip Code."
  );

  const maskTelInput = selector => {
    let $selector = $(selector);

    $selector.on("blur", function() {
      let intlNumber = $(this).intlTelInput("getNumber", intlTelInputUtils.numberFormat.INTERNATIONAL);
      if (intlNumber) {
        $('input[name="phone"]').val(intlNumber);
      }
    });

    $selector.intlTelInput({
        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/13.0.2/js/utils.js",
        hiddenInput: "phone",
        preferredCountries: ["us"]
      }).done(() => {
        if ($selector.data("value")) {
          $selector.val($selector.data("value"));
          $('input[name="phone"]').val($selector.data("value"));
        }

        $selector.trigger('blur');
      });
  };

  maskTelInput(".js-validate-checkout input[name=phone]");
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/validation.js